import { TableRow } from '../ui/table';

interface Props extends React.PropsWithChildren {
  onClick?: () => void;
}

function DataTableRow({ onClick, children }: Props) {
  return (
    <TableRow onClick={onClick} className={onClick ? 'cursor-pointer' : ''}>
      {children}
    </TableRow>
  );
}

export default DataTableRow;
